<template>
  <v-container>
    <v-card>
      <v-row align="center" class="py-1 px-2" no-gutters>
        <v-col>
          <v-breadcrumbs class="px-2" :items="breadcrumbsItems"></v-breadcrumbs>
        </v-col>
      </v-row>
      <v-container>
        <v-timeline :dense="$vuetify.breakpoint.smAndDown">
          <v-timeline-item
            v-for="(note, i) in notes"
            :key="i"
            :icon="note.icon"
            large
          >
            <template v-slot:opposite>
              <span v-text="note.year"></span>
            </template>
            <v-card>
              <v-card-title class="hidden-sm-and-down"
                >{{ $vuetify.lang.translator("version") }}
                {{ note.version }}</v-card-title
              >
              <v-card-title class="hidden-md-and-up"
                >{{ note.year }}<br />
                {{ $vuetify.lang.translator("version") }}
                {{ note.version }}</v-card-title
              >
              <v-card-text><span v-html="note.description"></span></v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "ReleaseNotes",
  data: () => ({
    breadcrumbsItems: [],
    notes: [],
    faNotes: [
      {
        icon: "fa-calendar-check",
        year: "25 خرداد 1401",
        version: "2.7.0",
        description:
          "افزودن نوع جدید برج" +
          "<br>" +
          "رفع مشکل نمایش اشتباه تاریخ در جدول صفحه فعالیت‌های کاربر"
      },
      {
        icon: "fa-calendar-check",
        year: "31 اردیبهشت 1401",
        version: "2.6.9",
        description:
          "نمایش آماده بودن بروزرسانی سامانه به کاربر" +
          "<br>" +
          "اعلام پشتیبانی نکردن سامانه از مرورگر IE به کاربر" +
          "<br>" +
          "رفع مشکل نمایش کد امنیتی در صفحه درخواست کد موقت" +
          "<br>" +
          "رفع مشکل نمایش کد امنیتی در صفحه تعیین رمز ورود جدید"
      },
      {
        icon: "fa-calendar-check",
        year: "29 اردیبهشت 1401",
        version: "2.6.5",
        description:
          "تولید کد امنیتی به شکل تصویری" +
          "<br>" +
          "تولید کد امنیتی به شکل صوتی" +
          "<br>" +
          "افزودن کد امنیتی به صفحه ورود" +
          "<br>" +
          "افزودن کد امنیتی به صفحه درخواست کد موقت" +
          "<br>" +
          "افزودن کد امنیتی به صفحه تعیین رمز ورود جدید"
      },
      {
        icon: "fa-calendar-check",
        year: "20 اردیبهشت 1401",
        version: "2.6.0",
        description:
          "افزوده شدن زبان انگلیسی" +
          "<br>" +
          "قابلیت انتخاب زبان برای هر کاربر در صفحه مشخصات" +
          "<br>" +
          "قابلیت تعیین زبان هنگام ایجاد/ویرایش کاربر"
      },
      {
        icon: "fa-calendar-check",
        year: "20 اسفند 1400",
        version: "2.5.2",
        description:
          "تغییر فرم‌های ایجاد و ویرایش برج جهت دریافت کد برج به صورت رشته"
      },
      {
        icon: "fa-calendar-check",
        year: "30 بهمن 1400",
        version: "2.5.0",
        description:
          "افزوده شدن بخش پشتیبانی" + "<br>" + "افزوده شدن بخش مدیریت پشتیبانی"
      },
      {
        icon: "fa-calendar-check",
        year: "16 بهمن 1400",
        version: "2.4.5",
        description:
          "فعال/غیرفعال سازی همه مدل‌ها" +
          "<br>" +
          "حذف تمام خطاهای یک دسته تصاویر"
      },
      {
        icon: "fa-calendar-check",
        year: "25 مهر 1400",
        version: "2.4.0",
        description:
          "رفع مشکل افزودن تصاویر در فایل kmz گزارش" +
          "<br>" +
          "جلوگیری از ایجاد مشکل در فایل pdf گزارش توسط تصاویر با ارتفاع زیاد" +
          "<br>" +
          "افزودن راهنمای نحوه تصویربرداری با پهپاد" +
          "<br>" +
          "افزودن بخش جستجوی تصاویر"
      },
      {
        icon: "fa-calendar-check",
        year: "18 مهر 1400",
        version: "2.3.6",
        description:
          "بهبود فرمت خروجی اکسل گزارش" +
          "<br>" +
          "افزودن آمار به انتهای خروجی اکسل گزارش" +
          "<br>" +
          "افزودن نمودار فراوانی خطاها در فایل اکسل گزارش" +
          "<br>" +
          "ایجاد منوی میز کار" +
          "<br>" +
          "افزودن خلاصه آمار سامانه با قابلیت برگرداندن آمار در بازه زمانی به صفحه میز کار" +
          "<br>" +
          "رفع مشکل نمایش تمام برج‌های یک خط روی نقشه"
      },
      {
        icon: "fa-calendar-check",
        year: "14 مهر 1400",
        version: "2.3.0",
        description: "قابلیت نصب سامانه به عنوان برنامه در مرورگرها"
      },
      {
        icon: "fa-calendar-check",
        year: "3 مهر 1400",
        version: "2.2.8",
        description:
          "تولید فایل KMZ برای یک خط و برج‌های آن" +
          "<br>" +
          "نمایش تاریخچه یک خط روی نقشه" +
          "<br>" +
          "رفع مشکل مرتب سازی برج‌ها در فایل kmz گزارش"
      },
      {
        icon: "fa-calendar-check",
        year: "2 شهریور 1400",
        version: "2.2.5",
        description:
          "تولید فایل pdf گزارش به صورت جداگانه برای هر برج" +
          "<br>" +
          "نمایش و دانلود فایل‌های pdf یک گزارش" +
          "<br>" +
          "نمایش نام هر تصویر زیر آن در فایل pdf گزارش"
      },
      {
        icon: "fa-calendar-check",
        year: "30 تیر 1400",
        version: "2.2.2",
        description:
          "درج آدرس سامانه روی تصاویر به صورت watermark" +
          "<br>" +
          "نمایش تعداد صفحات فایل pdf گزارش در سمت راست پایین صفحه" +
          "<br>" +
          "نمایش آدرس سامانه در فایل pdf گزارش در سمت چپ پایین صفحه" +
          "<br>" +
          "نمایش صحیح خطاها"
      },
      {
        icon: "fa-calendar-check",
        year: "31 خرداد 1400",
        version: "2.1.8",
        description:
          "بروزرسانی جمله حقوق مادی و معنوی برنامه" +
          "<br>" +
          "نمایش نام کامل سامانه روی لوگو" +
          "<br>" +
          "افزودن تصویر پس زمینه در صفحه ورود" +
          "<br>" +
          "جستجوی کاربران در صفحه کاربرها" +
          "<br>" +
          "نمایش تعداد کل صفحات گزارش در فایل pdf" +
          "<br>" +
          "افزودن لوگوهای پژوهشکده نیرو و ویراکویر در فایل pdf گزارش" +
          "<br>" +
          "افزودن عنوان به تمام صفحه‌های گزارش در فایل pdf" +
          "<br>" +
          "افزوده شدن فیلد سطح ولتاژ به تمام فرم‌های خط و ورود داده از اکسل" +
          "<br>" +
          "تعیین رنگ خط بین ایستگاه‌ها بر اساس سطح ولتاژ خط" +
          "<br>" +
          "تصحیح فایل خروجی اکسل گزارش" +
          "<br>" +
          "چک کردن صحت و درستی داده‌های ورودی از طریق فایل‌های اکسل" +
          "<br>" +
          "افزودن تاریخ انقضا قرار داد پیمانکار به همه فرم‌های لازم" +
          "<br>" +
          "قابلیت بروزرسانی تصاویر انواع برج توسط کاربران"
      },
      {
        icon: "fa-calendar-check",
        year: "7 خرداد 1400",
        version: "2.0.5",
        description:
          "مدیریت نمایش خطاهای تشخیصی برای مدیر ارشد" +
          "<br>" +
          "نمایش مختصات خطا برای مدیر ارشد" +
          "<br>" +
          "ترسیم نام خطا زیر عکس در صورتی که خطای تشخیصی بالای تصویر باشد" +
          "<br>" +
          "رفع مشکل ترسیم نام خطا در وسط" +
          "<br>" +
          "رفع مشکل نمایش فونت فارسی"
      },
      {
        icon: "fa-calendar-check",
        year: "اردیبهشت 1400",
        version: "2.0.0",
        description:
          "افزودن سطوح دسترسی در مدیریت کاربر" +
          "<br>" +
          "قابلیت دانلود لاگ" +
          "<br>" +
          "نمایش درصد دانلود فایل برای تمام دکمه‌های دانلود" +
          "<br>" +
          "نمایش درصد آپلود فایل برای تمام دکمه‌های آپلود" +
          "<br>" +
          "جانمایی برج از روی نقشه" +
          "<br>" +
          "ورود خطوط کارفرما از فایل اکسل" +
          "<br>" +
          "ورود برج‌های یک خط از فایل اکسل" +
          "<br>" +
          "ایجاد برج هنگام آپلود تصاویر اگر وجود نداشته باشد" +
          "<br>" +
          "تعیین مختصات برج از روی تصاویر دارای اطلاعات GPS" +
          "<br>" +
          "تغییر وضعیت دسته تصاویر در صورت داشتن دسترسی" +
          "<br>" +
          "ثبت و نمایش تمام عملیات انجام شده روی یک دسته تصاویر" +
          "<br>" +
          "تغییر وضعیت گزارش در صورت داشتن دسترسی" +
          "<br>" +
          "ثبت و نمایش تمام عملیات انجام شده روی یک گزارش" +
          "<br>" +
          "حذف خطا در صورت داشتن دسترسی" +
          "<br>" +
          "تکمیل آپلود تصاویر یک دسته در صورتی که تصاویر ناقص آپلود شده باشند" +
          "<br>" +
          "دانلود خروجی گزارش به فرمت KMZ قابل استفاده در برنامه Google Earth" +
          "<br>" +
          "قابلیت انتخاب بین تصاویر با کیفیت بالا و کم در تولید فایل pdf گزارش" +
          "<br>" +
          "تفکیک تصاویر دارای خطا در نمایش تصاویر" +
          "<br>" +
          "تعیین تصویر و نوع برج‌ها" +
          "<br>" +
          "رفع برخی مشکلات"
      },
      {
        icon: "fa-calendar-check",
        year: "دی 1399",
        version: "1.0.0",
        description: "انتشار نسخه اول"
      }
    ],
    enNotes: [
      {
        icon: "fa-calendar-check",
        year: "June 15, 2022",
        version: "2.6.9",
        description:
          "Added new tower type" +
          "<br>" +
          "Fixed bug in showing wrong date time in user activities page"
      },
      {
        icon: "fa-calendar-check",
        year: "May 21, 2022",
        version: "2.6.9",
        description:
          "Shows an update prompt to the user" +
          "<br>" +
          "Notify the IE user that the app does not support the IE browser" +
          "<br>" +
          "Fixed issue with displaying security code on reset password page" +
          "<br>" +
          "Fixed issue with displaying security code on new password setting page"
      },
      {
        icon: "fa-calendar-check",
        year: "May 19, 2022",
        version: "2.6.5",
        description:
          "Generates security code in the form of an image" +
          "<br>" +
          "Generates security code in audio form" +
          "<br>" +
          "Added security code to login page" +
          "<br>" +
          "Added security code to the temporary code request page" +
          "<br>" +
          "Added security code to reset password page"
      },
      {
        icon: "fa-calendar-check",
        year: "May 10, 2022",
        version: "2.6.0",
        description:
          "English language added" +
          "<br>" +
          "Ability to select the language for each user on the profile page" +
          "<br>" +
          "Ability to specify language when creating / editing user"
      },
      {
        icon: "fa-calendar-check",
        year: "March 11, 2022",
        version: "2.5.2",
        description:
          "Change tower creation and editing forms to receive tower code as a string"
      },
      {
        icon: "fa-calendar-check",
        year: "February 19, 2022",
        version: "2.5.0",
        description:
          "Added support section" + "<br>" + "Added support management section"
      },
      {
        icon: "fa-calendar-check",
        year: "February 5, 2022",
        version: "2.4.5",
        description:
          "Enable / disable all models" +
          "<br>" +
          "Delete all errors in a batch of images"
      },
      {
        icon: "fa-calendar-check",
        year: "October 17, 2021",
        version: "2.4.0",
        description:
          "Fixed an issue adding images to kmz report file" +
          "<br>" +
          "Avoid creating problems in the pdf file of the report by high-resolution images" +
          "<br>" +
          "Add a guide to how to shoot with a drone" +
          "<br>" +
          "Add image search section"
      },
      {
        icon: "fa-calendar-check",
        year: "October 10, 2021",
        version: "2.3.6",
        description:
          "Improved Excel report output format" +
          "<br>" +
          "Add statistics to the end of Excel report output" +
          "<br>" +
          "Add a graph of the frequency of errors in the Excel report file" +
          "<br>" +
          "Create a desktop menu" +
          "<br>" +
          "Add system statistics summary with the ability to return statistics to the desktop page in a timely manner" +
          "<br>" +
          "Fixed an issue with displaying all towers on a line on a map"
      },
      {
        icon: "fa-calendar-check",
        year: "October 6, 2021",
        version: "2.3.0",
        description: "Ability to install the system as a program in browsers"
      },
      {
        icon: "fa-calendar-check",
        year: "September 25, 2021",
        version: "2.2.8",
        description:
          "Generate a KMZ file for a line and its vertices" +
          "<br>" +
          "Show the history of a line on a map" +
          "<br>" +
          "Fixed a problem with sorting towers in the kmz report file"
      },
      {
        icon: "fa-calendar-check",
        year: "August 24, 2021",
        version: "2.2.5",
        description:
          "Generate report pdf file separately for each tower" +
          "<br>" +
          "View and download pdf files of a report" +
          "<br>" +
          "Display the name of each image below it in the report pdf file"
      },
      {
        icon: "fa-calendar-check",
        year: "July 21, 2021",
        version: "2.2.2",
        description:
          "Enter the system address on the images as a watermark" +
          "<br>" +
          "Display the number of pages of the report pdf file at the bottom right of the page" +
          "<br>" +
          "Display system address in pdf report file at the bottom left of the page" +
          "<br>" +
          "Correct display of errors"
      },
      {
        icon: "fa-calendar-check",
        year: "June 21, 2021",
        version: "2.1.8",
        description:
          "Update the material and intellectual rights of the program" +
          "<br>" +
          "Display the full system name on the logo" +
          "<br>" +
          "Add background image to login page" +
          "<br>" +
          "Search users on the users page" +
          "<br>" +
          "Show the total number of report pages in the pdf file" +
          "<br>" +
          "Add the logos of Niroo and Viraquire Research Institute in the report pdf file" +
          "<br>" +
          "Add title to all report pages in pdf file" +
          "<br>" +
          "Added voltage level field to all line forms and input data from Excel" +
          "<br>" +
          "Determine the line color between stations based on the line voltage level" +
          "<br>" +
          "Correct the output output file of the report" +
          "<br>" +
          "Checking the accuracy of the input data through Excel files" +
          "<br>" +
          "Add the contract expiration date to all required forms" +
          "<br>" +
          "Ability to update images of different types of towers by users"
      },
      {
        icon: "fa-calendar-check",
        year: "May 28, 2021",
        version: "2.0.5",
        description:
          "Manage the display of diagnostic errors for the senior manager" +
          "<br>" +
          "Display error coordinates for senior manager" +
          "<br>" +
          "Draw the error name below the image if the diagnostic error is above the image" +
          "<br>" +
          "Fixed an issue with drawing error names in the middle" +
          "<br>" +
          "Fixed the problem of displaying Persian fonts"
      },
      {
        icon: "fa-calendar-check",
        year: "April 21, 2021",
        version: "2.0.0",
        description:
          "Add access levels in user management" +
          "<br>" +
          "Ability to download logs" +
          "<br>" +
          "Display file download percentage for all download buttons" +
          "<br>" +
          "Display file upload percentage for all upload buttons" +
          "<br>" +
          "Locate the tower from the map" +
          "<br>" +
          "Entering client lines from an Excel file" +
          "<br>" +
          "Import towers of a line from an Excel file" +
          "<br>" +
          "Create a tower when uploading images if it does not exist" +
          "<br>" +
          "Determine the coordinates of the tower from images with GPS information" +
          "<br>" +
          "Change the status of image categories if user has privileges" +
          "<br>" +
          "Record and display all operations performed on a batch of images" +
          "<br>" +
          "Change the status of the report if user has privileges" +
          "<br>" +
          "Record and display all operations performed on a report" +
          "<br>" +
          "Delete error if you have access" +
          "<br>" +
          "Complete uploading images of a category if incomplete images are uploaded" +
          "<br>" +
          "Download the output of the report in KMZ format that can be used in Google Earth" +
          "<br>" +
          "Ability to choose between high quality and low quality images in pdf report output" +
          "<br>" +
          "Separate images with error in displaying images" +
          "<br>" +
          "Determine the image and type of towers" +
          "<br>" +
          "Fixed some bugs"
      },
      {
        icon: "fa-calendar-check",
        year: "ecember 21, 2020",
        version: "1.0.0",
        description: "Released the first version"
      }
    ]
  }),
  created() {
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("system")
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "changesTitle" }
    });
    this.notes =
      this.$store.getters.LANGUAGE == "fa" ? this.faNotes : this.enNotes;
  }
};
</script>
